import { QueryClientProvider as TanStackQueryClientProvider } from "@tanstack/react-query";

import { queryClient } from "@/shared/lib/react-query";

type QueryClientProviderProps = {
  children: React.ReactNode;
};

export const QueryClientProvider = ({ children }: QueryClientProviderProps) => {
  return (
    <TanStackQueryClientProvider client={queryClient}>
      {children}
    </TanStackQueryClientProvider>
  );
};
